
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import i18n from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import { translations } from './translations.ts';

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: 'ar', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    }
  });

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);